import { FormControl, Grid, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

interface ISwitchProps {
  titulo: string;
  estadoSwitch: boolean;
  setEstadoSwitch: React.Dispatch<React.SetStateAction<boolean>>;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
}

export default function SwitchComponente({
  estadoSwitch,
  setEstadoSwitch,
  titulo,
  disabled = false,
  onChange,
}: Readonly<ISwitchProps>) {
  return (
    <Grid item xs={12} sm={12} md={6} lg={6}>
      <Tooltip title={titulo} placement="top-start">
        <FormControl fullWidth>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              justifyItems: 'center',
              alignItems: 'center',
            }}
          >
            <IOSSwitch
              sx={{ m: 1 }}
              checked={estadoSwitch}
              onChange={() => {
                if (disabled) return;
                setEstadoSwitch(!estadoSwitch);
                onChange?.(!estadoSwitch);
              }}
              disabled={disabled}
            />
            <Typography style={{ width: '100%', fontFamily: 'sans-serif' }} variant="subtitle1">
              {titulo}
            </Typography>
          </div>
        </FormControl>
      </Tooltip>
    </Grid>
  );
}
